import {observable, action, makeObservable} from 'mobx';
import {DesignScreen} from '../../../stores/DesignScreen';
import {TreeDesignCollection} from './TreeDesignCollection';

export class TreeDesignScreen extends DesignScreen {
    @observable picdesign;

    constructor(screen, name) {
        super(screen, name);
        makeObservable(this);
        this.collection = new TreeDesignCollection(null);
    }

    setCollection(data) {
        this.picdesign = data.fields[0]?.picdesign;
        this.collection.insertFields(this, data.fields);
    }

    @action
    setPicDesign(value) {
        this.picdesign = value;
    }
}
